"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useInitializeContext = exports.useRadioContext = exports.RadioContext = void 0;
var react_1 = require("react");
var useControllableValue_1 = __importDefault(require("../../helpers/hook/useControllableValue"));
exports.RadioContext = react_1.createContext(undefined);
var useRadioContext = function () {
    var context = react_1.useContext(exports.RadioContext);
    if (!context) {
        throw new Error('useRadioContext must be inside a RadioGroup');
    }
    return context;
};
exports.useRadioContext = useRadioContext;
var useInitializeContext = function (_a) {
    var name = _a.name, selectedValue = _a.selectedValue, onChange = _a.onChange, onChanging = _a.onChanging;
    var _b = useControllableValue_1["default"]({
        value: selectedValue,
        onChanging: onChanging,
        onChange: onChange
    }), contextValue = _b[0], changeSelectedValue = _b[1];
    return {
        name: name,
        selectedValue: contextValue,
        changeSelectedValue: changeSelectedValue
    };
};
exports.useInitializeContext = useInitializeContext;
//# sourceMappingURL=RadioContext.js.map